module.exports = __webpack_public_path__ + "img/upload_event.97d9cf99.png";